export default __webpack_public_path__ + "static/media/local-product-img-banner.f5ae7d12.png";